import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

interface BranchCardSkeletonProps {
  count?: number;
}

const BranchCardSkeleton: React.FC<BranchCardSkeletonProps> = ({
  count = 1,
}) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="flex p-4 bg-white rounded-md shadow mb-4 w-full max-w-[700px]"
        >
          {/* Image skeleton */}
          <div className="w-[120px] h-[120px] mr-4">
            <Skeleton height={120} width={120} />
          </div>

          {/* Content skeleton */}
          <div className="flex flex-col justify-between flex-1 space-y-2">
            <Skeleton height={20} width="60%" />
            <Skeleton height={16} width="50%" />
            <Skeleton height={12} width="90%" />
            <Skeleton height={12} width="80%" />
            <div className="w-[100px] mt-2">
              <Skeleton height={32} />
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default BranchCardSkeleton;
